import { render, staticRenderFns } from "./ModalCreateTerm.vue?vue&type=template&id=0dd042b6"
import script from "./ModalCreateTerm.vue?vue&type=script&lang=js"
export * from "./ModalCreateTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports